export const SAMPLE_POTENTIAL_GRAPH_DATA = {
  last_period_total: 0,
  total: 1994441,
  stats: [{
    date: '2021-06-30T00:00:00Z',
    interested: 6,
    potential_reach: 45389,
  }, {
    date: '2021-07-31T00:00:00Z',
    interested: 3,
    potential_reach: 125332,
  }, {
    date: '2021-08-31T00:00:00Z',
    interested: 3,
    potential_reach: 45720,
  }, {
    date: '2021-09-30T00:00:00Z',
    interested: 6,
    potential_reach: 543000,
  }, {
    date: '2021-10-31T00:00:00Z',
    interested: 2,
    potential_reach: 1235000,
  }],
};

export const SAMPLE_INTERESTED_GRAPH_DATA = {
  interested_by_outlet_type: [
    {
      name: 'Blog Consumer',
      value: 3,
    },
    {
      name: 'Consumer Magazine',
      value: 15,
    },
    {
      name: 'Online consumer',
      value: 2,
    },
  ],
  interested_by_subject: [
    {
      name: 'Organic and Natural Foods',
      value: 2,
    },
    {
      name: 'Beauty',
      value: 6,
    },
    {
      name: 'Domestic Lifestyle',
      value: 3,
    },
    {
      name: 'Hair Care',
      value: 4,
    },
    {
      name: 'Fashion and wearing Apperel',
      value: 1,
    },
    {
      name: 'Arts and Entertainment Guides',
      value: 1,
    },
    {
      name: 'Nightlife',
      value: 1,
    },
    {
      name: 'Other',
      value: 2,
    },
  ],
};

export const SAMPLE_INTERESTED_CHART_DATA = {
  interested: 20,
  last_period_interested: 0,
  people_contacted: 400,
  last_period_people_contacted: 0,
};

export const SAMPLE_CAMPAIGN_SUMMARY_DATA = {
  count: 5,
  next: null,
  previous: null,
  results: [
    {
      name: 'October Campaign',
      launch_date: '2021-10-31T00:00:00Z',
      people_contacted: 100,
      opened: 44,
      interested: 6,
      expanded_interest: 6,
      completed: 0.6,
      potential_reach: 1235000,
    },
    {
      name: 'September Campaign',
      launch_date: '2021-09-30T00:00:00Z',
      people_contacted: 100,
      opened: 60,
      interested: 3,
      expanded_interest: 3,
      completed: 1,
      potential_reach: 543000,
    },
    {
      name: 'August Campaign',
      launch_date: '2021-08-31T00:00:00Z',
      people_contacted: 100,
      opened: 66,
      interested: 3,
      expanded_interest: 3,
      completed: 1,
      potential_reach: 45720,
    },
    {
      name: 'July Campaign',
      launch_date: '2021-07-31T00:00:00Z',
      people_contacted: 100,
      opened: 27,
      interested: 6,
      expanded_interest: 6,
      completed: 1,
      potential_reach: 125332,
    },
    {
      name: 'June Campaign',
      launch_date: '2021-06-30T00:00:00Z',
      people_contacted: 100,
      opened: 40,
      interested: 2,
      expanded_interest: 2,
      completed: 1,
      potential_reach: 45389,
    },
  ],
};

export const SAMPLE_TOP_LEADS_DATA = {
  count: 5,
  next: null,
  previous: null,
  results: [
    {
      id: 'f59d49e7-e9b9-4c6a-9f1d-607fa8eb46b1',
      contact_name: 'Jared Fluguer',
      outlet: 'Forbes',
      outlet_type: 'Consumer magazine',
      outlet_url: 'forbes.com',
      potential_reach: 5000000,
    },
    {
      id: '9265ec60-7348-4fd7-82fa-46228acc6dfb',
      contact_name: 'Celia Truman',
      outlet: 'USA Today',
      outlet_type: 'Online consumer',
      outlet_url: 'usatoday.com',
      potential_reach: 4000000,
    },
    {
      id: 'a904e1c7-2091-41c8-9d10-0b32a95449b0',
      contact_name: 'Alisa Justine',
      outlet: 'Motherly',
      outlet_type: 'Online consumer',
      outlet_url: 'mother.ly',
      potential_reach: 3000000,
    },
    {
      id: '62057e2f-d162-4905-8b4d-d9331ff1c372',
      contact_name: 'Alisa Justine',
      outlet: 'BuzzFeed',
      outlet_type: 'Blog, consumer',
      outlet_url: 'buzzfeed.com',
      potential_reach: 2000000,
    },
    {
      id: 'a8f9fe23-bc70-459e-87d1-6ab60a76c0d6',
      contact_name: 'Marie Condo',
      outlet: 'WeCare',
      outlet_type: 'Blog, consumer',
      outlet_url: 'blogger.com',
      potential_reach: 8230,
    },
  ],
};

export const SAMPLE_REPORT_CHART_DATA = [
  {
    date: '2021-06-30T00:00:00+0000',
    interested: 2,
    expanded_interest: 2,
    opened: 40,
  },
  {
    date: '2021-07-31T00:00:00+0000',
    interested: 6,
    expanded_interest: 6,
    opened: 27,
  },
  {
    date: '2021-08-31T00:00:00+0000',
    interested: 3,
    expanded_interest: 3,
    opened: 66,
  },
  {
    date: '2021-09-30T00:00:00+0000',
    interested: 3,
    expanded_interest: 3,
    opened: 60,
  },
  {
    date: '2021-10-31T00:00:00+0000',
    interested: 6,
    expanded_interest: 6,
    opened: 44,
  },
];

export default {
  ...SAMPLE_INTERESTED_GRAPH_DATA,
  ...SAMPLE_INTERESTED_CHART_DATA,
  report_charts: SAMPLE_REPORT_CHART_DATA,
  topLeads: SAMPLE_TOP_LEADS_DATA,
  campaigns: SAMPLE_CAMPAIGN_SUMMARY_DATA,
  potential_reach_charts: SAMPLE_POTENTIAL_GRAPH_DATA.stats,
  potential_reach_total: SAMPLE_POTENTIAL_GRAPH_DATA.total,
  last_period_potential_reach_total: SAMPLE_POTENTIAL_GRAPH_DATA.last_period_total,
};
